<div class="c__video-container">
  <div class="c__media-wrapper">
    <div sd-loader [loading]="isLoading"></div>
    <div class="c--media is-video {{isLoading ? 'is-hidden' : ''}}">
      <video #videoElement playsinline (canplay)="videoIsLoaded()">
        @for (media of videoSequencer?.medias; track media) {
          <source
            [attr.src]="media.url"
            [attr.type]="media.mime">
        }
      </video>
    </div>
  </div>
  <button #buttonPrev
    sd-button
    type="button"
    [isIcon]="true"
    icon="icon-arrow-left"
    class="c__button-prev {{isPrevBtnDisabled ? 'is-disabled' : ''}}"
    (click)="clickPrevBtn(isPrevBtnDisabled)"
    [attr.aria-disabled]="isPrevBtnDisabled">
    <span class="is-visually-hidden">{{ 'videoSequencer.a11yprev' | translate }}{{ context ? ' - ' + context : '' }}</span>
  </button>
  <button #buttonNext
    sd-button
    type="button"
    [isIcon]="true"
    icon="icon-arrow-right"
    class="c__button-next {{isNextBtnDisabled ? 'is-disabled' : ''}}"
    (click)="clickNextBtn(isNextBtnDisabled)"
    [attr.aria-disabled]="isNextBtnDisabled">
    <span class="is-visually-hidden">{{ 'videoSequencer.a11ynext' | translate }}{{ context ? ' - ' + context : '' }}</span>
  </button>
</div>
<div class="c__cue-points">
  <ul>
    @for (cuePoint of videoSequencer?.cuePoints; track cuePoint) {
      <li
        class="{{ $index === currentCuePoint ? 'is-active' : '' }}">
        <button type="button"
          class="c__dots"
          (click)="goToCuePoint($index)"
          [attr.aria-current]="$index === currentCuePoint"
          [attr.aria-describedby]="$index === currentCuePoint ? descriptionUUID : ''">
          <span class="is-visually-hidden">{{ ($index + 1) }}{{ context ? ' - ' + context : '' }}</span>
        </button>
      </li>
    }
  </ul>
</div>

@if (videoSequencer?.cuePoints) {
  <p [id]="descriptionUUID"
    class="c__description"
    [attr.aria-live]="ariaLiveState"
    aria-atomic="true">
    {{ videoSequencer?.cuePoints[currentCuePoint].description }}
  </p>
}
